import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import StyledBackButton from '../../Common/StyledBackButton';

interface IDataRequestSuccessModalProps {
  handleDismiss: () => void;
}
const StyledTypography = styled(Typography)({
  '& span': {
    background: 'white',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
});

function DataRequestSuccessModal({ handleDismiss }: IDataRequestSuccessModalProps) {
  const { t } = useTranslation();

  return (
    <Grid container flexDirection="column">
      <Grid
        item
        p="36px"
        gap="11px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          background:
            'linear-gradient(175.46deg, rgba(87, 177, 90, 0.2) -9.81%, rgba(47, 125, 50, 0.2) 96.32%)',
        }}
        width="100%"
        borderRadius="10px 10px 0 0"
      >
        {' '}
        <img src="/assets/icons/check-circle-new.svg" alt="bin" role="presentation" width={70} />
        <StyledTypography
          variant="title2Bold"
          textAlign="center"
          sx={{
            color: 'linear-gradient(175.46deg, #57B15A -9.81%, #2F7D32 96.32%)',
          }}
        >
          {t('settings.privacySettings.dataRequest.toastMessage')}
        </StyledTypography>
      </Grid>

      <Grid item p="52px 32px 36px 32px" gap={6} display="flex" flexDirection="column">
        <Typography variant="bodyRegular" color="primary" textAlign="center">
          {t('settings.privacySettings.dataRequest.requestInfo')}
        </Typography>
        <Box display="flex" justifyContent="center">
          <StyledBackButton variant="outlined" onClick={handleDismiss} fullWidth>
            {t('common.dismiss')}
          </StyledBackButton>
        </Box>
      </Grid>
    </Grid>
  );
}

export default DataRequestSuccessModal;
